// Constants
export const MENU_SET_IS_OPEN = 'MENU_SET_IS_OPEN';

// Actions
export const setMenuIsOpen = isOpen => {
  return {
    type: MENU_SET_IS_OPEN,
    isOpen
  };
};

// Initial State
export const initialState = {
  isMenuOpen: false,
  footerItems: {
    privacy: {
      label: 'Privacy Policy, Report Fraud & Abuse, Legal Disclaimer',
      href: 'https://www.bcidaho.com/privacy-and-terms'
    },
    nondiscrimination: {
      label: 'Nondiscrimination Notice',
      href: 'https://members.bcidaho.com/resources/pdfs/03/3-1187-Blue-Cross-of-Idaho-Non-Discrimination-Statement.pdf'
    },
    developers: {
      label: 'For Developers',
      href: 'https://www.bcidaho.com/for-developers'
    }
  }
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case MENU_SET_IS_OPEN:
      return {
        ...state,
        isMenuOpen: action.isOpen
      };
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        isMenuOpen: false
      };
    default:
      return state;
  }
};
